import React, { useState } from 'react';
import './About.css';

const About = () => {
  const [showAllCapabilityImages, setShowAllCapabilityImages] = useState(false);

  // Generate array of capability images
  const capabilityImages = Array.from({ length: 16 }, (_, index) => 
    `/images/nangLuc/Công bố năng lực Trung tâm thí nghiệm vật liệu và Khảo sát địa chất-images-${index}.jpg`
  );

  const displayedImages = showAllCapabilityImages ? capabilityImages : capabilityImages.slice(0, 3);
  return (
    <div className="about-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Giới thiệu công ty</h1>
          <p>Tìm hiểu về DSC.JSC - Trắc địa Hải Phòng</p>
        </section>

        {/* Company Overview */}
        <section className="company-overview">
          <div className="container">
            <div className="overview-content">
              <div className="overview-text">
                <h2>Về chúng tôi</h2>
                <p>
                  Công ty Cổ phần Khảo sát Thiết kế và Dịch vụ Thương mại Miền Bắc (DSC.JSC) 
                  được thành lập và đi vào hoạt động theo giấy chứng nhận đăng ký kinh doanh 
                  số 0200647813 do Sở kế hoạch đầu tư Hải Phòng cấp lần đầu ngày 28/9/2005, 
                  đăng ký thay đổi lần 9 ngày 05 tháng 01 năm 2026.
                </p>
                <p>
                  Với đội ngũ kỹ sư được đào tạo chính quy từ các Trường đại học: Mỏ - địa chất; 
                  GTVT; Xây dựng; Thủy lợi và đại học Bách Khoa Hà Nội nhiều năm kinh nghiệm 
                  trong công việc, có kinh nghiệm nhiều năm công tác tại các Công ty lớn trong nước.
                </p>
                <p>
                  DSC có đội ngũ cán bộ lãnh nghệ nhiều năm kinh nghiệm trong việc khảo sát 
                  thi công trên mọi địa hình phức tạp với sự hỗ trợ của số lượng lớn máy móc thiết bị 
                  phục vụ cho khảo sát địa hình, địa chất tương đối hiện đại hiện nay.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Company Info */}
        <section className="company-info">
          <div className="container">
            <h2>Thông tin công ty</h2>
            <div className="info-grid">
              <div className="info-card">
                <h3>Thông tin pháp lý</h3>
                <ul>
                  <li><strong>Tên công ty:</strong> Công ty Cổ phần Khảo sát Thiết kế và Dịch vụ Thương mại Miền Bắc</li>
                  <li><strong>Tên tiếng Anh:</strong> MIENBAC TRANDING SERVICE AND DESIGN SURVEY JOINT STOCK COMPANY</li>
                  <li><strong>Tên viết tắt:</strong> DSC.JSC</li>
                  <li><strong>Mã số doanh nghiệp:</strong> 0200647813</li>
                  <li><strong>Ngày cấp lần đầu:</strong> 28/09/2005</li>
                  <li><strong>Đăng ký thay đổi lần 9:</strong> 05/01/2026</li>
                  <li><strong>Nơi cấp:</strong> Sở Kế hoạch và Đầu tư Hải Phòng</li>
                  <li><strong>Tài khoản:</strong> 2581100001268 tại Ngân hàng TMCP Quân đội - Chi nhánh Hải Phòng</li>
                </ul>
              </div>
              <div className="info-card">
                <h3>Thông tin liên hệ</h3>
                <ul>
                  <li><strong>Trụ sở:</strong> Số 4/A1 Chung cư Tinh Thành Quốc tế, Khu đô thị Cựu Viên, Phường Kiến An, Thành phố Hải Phòng, Việt Nam</li>
                  <li><strong>Trung tâm thí nghiệm:</strong> LAS-XD27.004, Lô 258 - dự án An Đồng – Phường An Hải – Thành phố Hải Phòng (Giấy chứng nhận số 3335/GCN-SXD ngày 05/7/2024)</li>
                  <li><strong>Tel/Fax:</strong> 0225.3920691</li>
                  <li><strong>Email:</strong> mienbacdsc@gmail.com</li>
                  <li><strong>Website:</strong> tracdiahaiphong.com</li>
                  <li><strong>Người đại diện:</strong> Ông Vũ Văn Đáp - Chủ tích HĐQT (kiêm Giám Đốc)</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="mission-vision">
          <div className="container">
            <h2>Sứ mệnh - Tầm nhìn - Giá trị cốt lõi</h2>
            <div className="mv-grid">
              <div className="mv-card">
                <h3>Sứ mệnh</h3>
                <p>
                  Cung cấp các dịch vụ khảo sát, thiết kế và tư vấn chuyên nghiệp, 
                  góp phần phát triển hạ tầng và xây dựng bền vững tại Việt Nam. 
                  Đồng hành cùng khách hàng trong mọi dự án với chất lượng cao nhất.
                </p>
              </div>
              <div className="mv-card">
                <h3>Tầm nhìn</h3>
                <p>
                  Trở thành công ty hàng đầu trong lĩnh vực khảo sát và thiết kế 
                  kỹ thuật tại miền Bắc Việt Nam. Phát triển thành tập đoàn đa ngành 
                  với uy tín và thương hiệu được khách hàng tin tưởng.
                </p>
              </div>
              <div className="mv-card">
                <h3>Giá trị cốt lõi</h3>
                <ul>
                  <li>Chuyên nghiệp trong mọi hoạt động</li>
                  <li>Uy tín và minh bạch</li>
                  <li>Chất lượng là ưu tiên hàng đầu</li>
                  <li>Đổi mới và sáng tạo</li>
                  <li>Phục vụ khách hàng tận tâm</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Business Areas */}
        <section className="business-areas">
          <div className="container">
            <h2>Các ngành nghề kinh doanh chính</h2>
            <div className="business-grid">
              <div className="business-card">
                <h3>1. Hoạt động đo đạc bản đồ</h3>
                <ul>
                  <li>Hoạt động thăm dò địa chất, nguồn nước</li>
                  <li>Thiết kế cấp thoát nước, đường nội bộ trong đô thị, khu công nghiệp</li>
                  <li>Thiết kế kết cấu công trình xây dựng dân dụng và công nghiệp</li>
                  <li>Khảo sát địa hình các công trình xây dựng</li>
                  <li>Khảo sát địa chất công trình</li>
                  <li>Giám sát công tác xây dựng và hoàn thiện các công trình giao thông đường bộ, cầu</li>
                </ul>
              </div>
              <div className="business-card">
                <h3>2. Thi nghiệm, kiểm tra chất lượng vật liệu xây dựng</h3>
                <p>Thí nghiệm các loại vật liệu xây dựng theo tiêu chuẩn kỹ thuật</p>
              </div>
              <div className="business-card">
                <h3>3. Tư vấn lập dự án đầu tư xây dựng</h3>
                <p>Lập hồ sơ dự án đầu tư các công trình xây dựng</p>
              </div>
              <div className="business-card">
                <h3>4. Bán buôn máy móc, thiết bị và phụ tùng máy khái khoáng, xây dựng</h3>
                <ul>
                  <li>Bán buôn máy móc, thiết bị điện, vật liệu điện</li>
                  <li>Bán buôn máy móc, thiết bị và phụ tùng máy dệt, may, da giày</li>
                  <li>Bán buôn máy móc, thiết bị y tế</li>
                  <li>Bán buôn thiết bị thủy lực, máy nén khí, máy cơ khí, thiết bị phòng cháy chữa cháy</li>
                </ul>
              </div>
              <div className="business-card">
                <h3>5. Sửa chữa, bảo dưỡng và lắp đặt máy móc và thiết bị điện tử và quang học</h3>
              </div>
              <div className="business-card">
                <h3>6. Tư vấn lập đề án đánh giá tác động môi trường</h3>
                <p>Lập báo cáo quan trắc môi trường, lập báo cáo thẩm định khai thác khoáng sản và nguồn nước</p>
              </div>
            </div>
          </div>
        </section>

        {/* Certifications */}
        <section className="certifications">
          <div className="container">
            <h2>Chứng nhận và Năng lực</h2>
            <div className="cert-grid">
              <div className="cert-item">
                <h4>Giấy phép hoạt động</h4>
                <p>Được cấp phép hoạt động hợp pháp theo GPKD số 0200647813 do Sở KH&ĐT Hải Phòng cấp</p>
              </div>
              <div className="cert-item">
                <h4>Trung tâm thí nghiệm LAS-XD27.004</h4>
                <p>Giấy chứng nhận số 3335/GCN-SXD ngày 05/7/2024 với 102 chỉ tiêu thí nghiệm trong 12 nhóm chuyên ngành</p>
              </div>
              <div className="cert-item">
                <h4>Đội ngũ chuyên gia</h4>
                <p>Kỹ sư có chứng chỉ hành nghề và nhiều năm kinh nghiệm từ các trường đại học danh tiếng</p>
              </div>
              <div className="cert-item">
                <h4>Tiêu chuẩn quốc tế</h4>
                <p>Thí nghiệm theo tiêu chuẩn TCVN, ASTM, AASHTO, ISO với thiết bị hiện đại</p>
              </div>
            </div>
          </div>
        </section>

        {/* Laboratory Capabilities */}
        <section className="lab-capabilities-section">
          <div className="container">
            <h2>Năng lực Trung tâm Thí nghiệm</h2>
            <div className="lab-overview">
              <p>Trung tâm thí nghiệm vật liệu và khảo sát địa chất LAS-XD27.004 được trang bị đầy đủ thiết bị hiện đại, đáp ứng 102 chỉ tiêu thí nghiệm theo các tiêu chuẩn quốc gia và quốc tế.</p>
            </div>
            
            <div className="lab-categories">
              <div className="category-row">
                <div className="category-item">
                  <h4>🏗️ Vật liệu kết dính (3 chỉ tiêu)</h4>
                  <p>Xi măng: độ mịn, bền uốn-nén, thời gian đông kết</p>
                </div>
                <div className="category-item">
                  <h4>🪨 Cốt liệu (12 chỉ tiêu)</h4>
                  <p>Cỡ hạt, khối lượng riêng, độ hao mòn Los Angeles</p>
                </div>
                <div className="category-item">
                  <h4>🧱 Bê tông & Vữa (14 chỉ tiêu)</h4>
                  <p>Cường độ nén, độ sụt, khối lượng thể tích</p>
                </div>
              </div>
              
              <div className="category-row">
                <div className="category-item">
                  <h4>🔨 Gạch các loại (8 chỉ tiêu)</h4>
                  <p>Gạch bê tông, đất sét nung, gốm ốp lát</p>
                </div>
                <div className="category-item">
                  <h4>⚙️ Kim loại & Hàn (5 chỉ tiêu)</h4>
                  <p>Thử kéo, uốn, kiểm tra chất lượng mối hàn</p>
                </div>
                <div className="category-item">
                  <h4>🌍 Cơ lý đất (18 chỉ tiêu)</h4>
                  <p>Giới hạn Atterberg, CBR, SPT, độ chặt Proctor</p>
                </div>
              </div>
              
              <div className="category-row">
                <div className="category-item">
                  <h4>🛣️ Nhựa đường (8 chỉ tiêu)</h4>
                  <p>Độ kim lún, kéo dài, nhiệt độ hóa mềm</p>
                </div>
                <div className="category-item">
                  <h4>🛤️ Bê tông nhựa (20 chỉ tiêu)</h4>
                  <p>Marshall, hàm lượng nhựa, thiết kế hỗn hợp</p>
                </div>
                <div className="category-item">
                  <h4>💧 Hóa nước (5 chỉ tiêu)</h4>
                  <p>pH, Cl⁻, SO₄²⁻, cặn không tan, tạp chất hữu cơ</p>
                </div>
              </div>
            </div>
            
            <div className="lab-standards">
              <h3>Tiêu chuẩn áp dụng</h3>
              <div className="standards-grid">
                <div className="standard-item">
                  <span className="standard-flag">🇻🇳</span>
                  <span>TCVN (Tiêu chuẩn Việt Nam)</span>
                </div>
                <div className="standard-item">
                  <span className="standard-flag">🇺🇸</span>
                  <span>ASTM (American Society for Testing and Materials)</span>
                </div>
                <div className="standard-item">
                  <span className="standard-flag">🛣️</span>
                  <span>AASHTO (American Association of State Highway)</span>
                </div>
                <div className="standard-item">
                  <span className="standard-flag">🌍</span>
                  <span>ISO (International Organization for Standardization)</span>
                </div>
              </div>
            </div>
            
            {/* Download Section */}
            <div className="about-download-section">
              <h3>📄 Công bố năng lực thí nghiệm chuyên ngành xây dựng</h3>


              {/* Capability Images Gallery */}
              <div className="about-capability-images-section">
                
                <div className="about-capability-images-grid">
                  {displayedImages.map((imageSrc, index) => (
                    <div key={index} className="about-capability-image-item">
                      <img 
                        src={imageSrc} 
                        alt={`Năng lực thí nghiệm ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
                
                <div className="about-capability-images-controls">
                  <button 
                    className="btn btn-outline"
                    onClick={() => setShowAllCapabilityImages(!showAllCapabilityImages)}
                  >
                    {showAllCapabilityImages ? (
                      <>
                        <span>📤</span> Thu gọn
                      </>
                    ) : (
                      <>
                        <span>📥</span> Hiển thị thêm ({capabilityImages.length - 3} hình)
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;